const mutations = {
  CorpId (state, string) {
    state.corpId = string
  },
  userInfo (state, obj) {
    state.userInfo = obj
  },
  changeName (state, string) {
    state.userInfo.FullName = string
  },
  menuShow (state, obj) {
    state.menuShow = obj
  },
  projectList (state, obj) {
    state.projectList = obj
  },
  getJobSite (state, str) {
    state.jobsiteID = str
    state.preJobsiteID = state.jobsiteID
  },
  clearJobSite (state) {
    state.jobsiteID = ''
    state.jobsiteName = ''
    state.jobsiteLocation = ''
  },
  getJobsiteName (state, str) {
    state.jobsiteName = str
  },
  getJobsiteLocation (state, str) {
    state.jobsiteLocation = str
  },
  getCreator (state, str) {
    state.CreatorId = str
  },
  getCorpUser (state, arr) {
    state.cropUser = arr
  },
  getProjectMember (state, arr) {
    state.projectUser = arr
  },
  getTasksStatus (state, arr) {
    state.taskStatus = arr
  },
  getTasksTypes (state, arr) {
    state.taskType = arr
  },
  getTaskChecklistTemplates (state, arr) {
    state.taskChecklistTemplates = arr
  },
  getTaskTemplates (state, arr) {
    state.taskTemplates = arr
  },
  getTaskWorkTypes (state, arr) {
    state.taskWorkType = arr
  },
  getTaskGroup (state, arr) {
    state.taskGroup = arr
  },
  getReportType (state, arr) {
    state.reportType = arr
  },
  setPlan (state, obj) {
    state.plan = obj
  },
  setPlanCondition (state, obj) {
    state.planCondition = obj
  },
  showManagement (state, obj) {
    state.showManagement = obj
  },
  mockUserInfo (state, obj) {
    state.mockUserInfo = obj
  },
  measureUnitType (state, obj) {
    state.measureUnitType = obj
  },
  temperatureUnit (state, obj) {
    state.temperatureUnit = obj
  },
  M2Integration (state, obj) {
    state.M2Integration = obj
  },
  changeAvatar (state, string) {
    state.userInfo.Avatar = string
    state.avatar = string
  },
  corpName (state, string) {
    state.corpName = string
  },
  getUserContactCorps (state, arr) {
    state.userContactCorps = arr
  },
  hasCloudGroup (state, obj) {
    state.hasCloudGroup = obj
  },
  setCorporationCondition (state, obj) {
    state.corporationCondition = obj
  },
  setProjectCondition (state, obj) {
    state.projectCondition = obj
  },
  setCorporationConditionOrderby (state, val) {
    state.corporationConditionOrderby = val
  },
  setPlanConditionOrderby (state, val) {
    state.planConditionOrderby = val
  },
  setTaskConditionOrderby (state, val) {
    state.taskConditionOrderby = val
  },
  setReportConditionOrderby (state, val) {
    state.reportConditionOrderby = val
  },
  setProductConditionOrderby (state, val) {
    state.productConditionOrderby = val
  },
  setPhotoConditionOrderby (state, val) {
    state.photoConditionOrderby = val
  },
  setDocumentsConditionOrderby (state, val) {
    state.documentsConditionOrderby = val
  },
  clearAll (state) {
    state.corpId = ''
    state.userInfo = {}
    state.menuShow = false
    state.jobsiteID = ''
    state.preJobsiteID = ''
    state.jobsiteName = ''
    state.jobsiteLocation = ''
    state.CreatorId = ''
    state.projectList = []
    state.cropUser = []
    state.projectUser = []
    state.taskStatus = []
    state.taskType = []
    state.taskChecklistTemplates = []
    state.taskTemplates = []
    state.taskWorkType = []
    state.taskGroup = []
    state.reportType = []
    state.plan = {}
    state.planCondition = {}
    state.showManagement = false
    state.mockUserInfo = {}
    state.measureUnitType = ''
    state.temperatureUnit = ''
    state.M2Integration = false
    state.corpName = ''
    state.avatar = ''
    state.userContactCorps = []
    state.shasCloudGroup = false
    state.diag.data.pdfToolStyle = {
      color: '#FF0000',
      strokeThickness: 4,
      highlightStrokeThickness: 48,
      fontSize: 67
    }
    state.corporationCondition = {}
    state.projectCondition = {}
  },
  planTabType (state, obj) {
    state.planTabType = obj
  }
}
export default mutations
